import React, {useMemo} from "react";
import CanvasJSReact from "../../../assets/canvasjs.react";
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const CourseOccupancyChart = ({data}) => {
    const options = useMemo(() => {
        if (!data) return null;

        return {
            theme: "light2",
            title: { text: "Obsazenost kurzů" },
            axisY: { includeZero: true, suffix: "Míst" },
            axisX: { labelAngle: -30, labelFontSize: 12, interval: 1 },
            toolTip: { shared: true },
            data: [
                { type: "area", name: "Míst", showInLegend: true, dataPoints: data.capacityArea },
                { type: "area", name: "Zájemců", showInLegend: true, dataPoints: data.interestedArea },
                { type: "area", name: "Náhradníků", showInLegend: true, dataPoints: data.alternate },
                { type: "area", name: "Zapsáno", showInLegend: true, dataPoints: data.notAlternate }
            ]
        };
    }, [data]);

    if (!options) return null;

    return (
        <div className="dashboard-charts-occupancy-chart">
            <CanvasJSChart options={options}/>
        </div>
    );
};

export default CourseOccupancyChart;
